import { useState } from "react";
import WS from "./webservice";
import { MapPin } from "lucide-react";

import * as S from "./styles";


function AutoComplete({ coords, onSelect, alturaOffSet }) {
  const [suggestions, setSuggestions] = useState([]);
  const [inputValue, setInputValue] = useState("");
  let timer1 = null;

  const handleSearchChange = (e) => {
    setInputValue(e.target.value);
    if (e.target.value.length > 3) {
      timer1 = setTimeout(() => fetchSuggestions(e.target.value), 3000);
    }
  };

  const fetchSuggestions = async (address) => {
    // Chamar o endpoint de autocomplete
    try {
      let dados = await WS.autocomplete(address, coords);
      if (dados) {
        setSuggestions(dados);
      } else {
        setSuggestions([]);
      }
    } catch (error) {
      console.error("Erro ao buscar sugestões de autocomplete:", error);
      setSuggestions([]);
    }
  };

  const handleSelect = (address) => {
    clearTimeout(timer1);
    setInputValue(address.fullAddress);
    WS.placeidserver(address.place_id, address.text, coords.latitude, coords.longitude).then((resposta) => {
      onSelect(resposta);
      setSuggestions([]);
    });
  };

  return (<>
      <S.DetailLargeBox>
        <S.InputGroup>
      {inputValue.length > 0 && (<span>🔍 Para Onde Vamos?</span>)}
      <S.InputWrapper>
      <input
        type="text"
        value={inputValue}
        placeholder="🔍 Para Onde Vamos?"
        onChange={handleSearchChange}
      />
      </S.InputWrapper></S.InputGroup>
      </S.DetailLargeBox>
      {suggestions.length > 0 && (<S.DetailLargeBox>
        {suggestions.map((item, index) => (
          <S.PrimaryButton secondary={"true"}
            key={index}
            onClick={() => handleSelect(item)}>
            <MapPin style={{ marginRight: 8 }} />{item.fullAddress}
          </S.PrimaryButton>
        ))}
      </S.DetailLargeBox>)}</>
  );
}
export default AutoComplete;
